import React, { CSSProperties, useState } from "react";

// ----------------------------  InfoTip  ----------------------------
// Small info icon that shows configured details on hover or keyboard focus.
// Renders nothing when there are no details.

interface InfoTipProps {
  text?: string;
  // names what the details are about, for screen readers
  label: string;
  size?: string;
}

const InfoTip: React.FC<InfoTipProps> = ({ text, label, size = "1.1em" }) => {
  const [open, setOpen] = useState(false);
  const details = text?.trim();
  if (!details) return null;

  return (
    <span style={wrap} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <span
        role="img"
        tabIndex={0}
        aria-label={`Details: ${label}`}
        style={{ ...icon, width: size, height: size, fontSize: `calc(${size} * 0.7)` }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        // the icon sits inside option labels; hovering or clicking it must not pick the option
        onClick={(e) => e.preventDefault()}
      >
        i
      </span>
      {open && (
        <span role="tooltip" style={popover}>
          {details}
        </span>
      )}
    </span>
  );
};

// ----------------------------  Styles  ----------------------------

const wrap: CSSProperties = {
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  marginLeft: "6px",
  verticalAlign: "middle",
};

const icon: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  border: "1px solid #6b7280",
  color: "#6b7280",
  fontWeight: 700,
  fontStyle: "italic",
  fontFamily: "Georgia, serif",
  cursor: "help",
  lineHeight: 1,
  flexShrink: 0,
};

const popover: CSSProperties = {
  position: "absolute",
  top: "calc(100% + 6px)",
  left: 0,
  zIndex: 1000,
  width: "max-content",
  maxWidth: "320px",
  padding: "8px 10px",
  borderRadius: "6px",
  background: "#111827",
  color: "white",
  fontSize: "0.9rem",
  fontWeight: 400,
  fontStyle: "normal",
  lineHeight: 1.4,
  whiteSpace: "pre-wrap",
  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
};

export default InfoTip;
